var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 49,
    viewBox: "0 0 33 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    clipPath: "url(#clip0_27832_33633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6636 47.4249L26.6836 43.5649C26.6836 42.1249 26.8936 40.7049 27.3036 39.3249C28.2636 36.0249 30.1036 29.7649 30.8536 27.7049C31.8836 24.8649 31.6336 24.3449 30.0736 20.9849C28.5236 17.6249 26.9736 12.4549 26.1936 11.1549C25.4136 9.85485 20.7636 2.35485 19.2136 1.58485C17.1236 1.42485 15.8736 3.50485 16.2836 5.44485C16.6036 6.98485 17.5636 7.82485 18.4236 8.55485C18.8536 10.1749 20.0036 12.0849 20.9736 12.8649C21.2236 13.9649 21.7636 14.7849 22.4436 15.4649",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6934 47.425C11.6934 44.985 11.9034 42.815 8.79336 39.965C5.69336 37.125 6.12336 35.035 4.55336 32.565C2.89336 29.965 1.19336 24.425 1.19336 23.295C1.19336 22.165 5.91336 20.395 7.69336 24.415C8.66336 26.615 7.96336 27.045 9.26336 28.335C10.5534 29.625 12.6234 30.145 15.4734 28.075C18.3234 26.005 18.5734 25.745 18.0634 23.935C16.8034 23.505 14.8034 21.885 14.2834 21.365C13.5034 21.625 10.8434 21.545 9.54336 21.165C8.35336 21.785 6.31336 22.355 5.02336 22.025C4.10336 21.785 2.44336 19.765 2.35336 17.435C5.71336 16.655 12.3634 14.615 13.1434 14.875C13.9234 15.135 22.3234 18.255 23.4834 18.755C24.6434 19.255 25.0634 19.625 25.5534 20.915",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4837 4.63501C11.4737 5.61501 11.5737 7.38501 12.6537 9.05501C13.5137 10.375 14.2137 10.885 15.1737 11.185C15.6037 11.935 16.6137 12.795 17.5637 13.475",
    stroke: "#0C9BED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27832_33633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.28,
    height: 47.85,
    fill: "white",
    transform: "translate(0.193359 0.574951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.0c7391a8152d31b5dbface8cf98af13a.svg";
export { ForwardRef as ReactComponent };